import { useNavigate } from "react-router-dom";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import InventoryIcon from "@mui/icons-material/Inventory";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { rootProtectedPath, services } from "data/authData";
import { mboLfsQtyRecoDashboardServices } from "./data";
import { Panel, explorePageSx } from "./sharedStyles";

const MboLfsQtyRecoExplore = () => {
	const navigate = useNavigate();

	const handleServiceClick = (path) => {
		navigate(`/${rootProtectedPath}/${services.mbo_lfs_qty_reco.path}/${path}`);
	};

	const serviceItems = Object.values(mboLfsQtyRecoDashboardServices).flatMap((service) =>
		Object.values(service.types || {}).filter((item) => item.display)
	);

	return (
		<Box sx={explorePageSx}>
			<Stack direction="row" spacing={1.5} alignItems="center" mb={2.5}>
				<Box
					sx={{
						width: 40,
						height: 40,
						borderRadius: 1.5,
						display: "grid",
						placeItems: "center",
						bgcolor: "#fff",
						border: "1px solid #e6e8ec",
						color: "#1f2937",
					}}
				>
					<InventoryIcon sx={{ fontSize: 22 }} />
				</Box>
				<Box>
					<Typography variant="caption" color="text.secondary" fontWeight={600} letterSpacing={0.4}>
						FINANCE & ACCOUNTS
					</Typography>
					<Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.25, color: "#111827" }}>
						MBO LFS Qty Reco
					</Typography>
					<Typography variant="body2" color="text.secondary">
						Customer quantity reconciliation — summary and line detail
					</Typography>
				</Box>
			</Stack>

			<Grid container spacing={2}>
				{serviceItems.map((item) => (
					<Grid item xs={12} sm={6} md={4} key={item.key}>
						<Panel
							onClick={() => handleServiceClick(item.key)}
							sx={{
								p: 2.25,
								height: "100%",
								cursor: "pointer",
								transition: "border-color 0.15s ease, box-shadow 0.15s ease",
								"&:hover": {
									borderColor: "#9ca3af",
									boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
								},
							}}
						>
							<Box
								sx={{
									width: 38,
									height: 38,
									borderRadius: 1.5,
									display: "grid",
									placeItems: "center",
									bgcolor: "#f3f4f6",
									color: "#1f2937",
									mb: 1.5,
									"& .MuiSvgIcon-root": { fontSize: 20 },
								}}
							>
								{item.icon}
							</Box>
							<Typography variant="subtitle1" fontWeight={700} sx={{ color: "#111827", mb: 0.5 }}>
								{item.name}
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 2, minHeight: 40 }}>
								{item.description}
							</Typography>
							<Stack direction="row" alignItems="center" spacing={0.5} color="#1f2937">
								<Typography variant="body2" fontWeight={600}>
									Open
								</Typography>
								<ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
							</Stack>
						</Panel>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default MboLfsQtyRecoExplore;
